import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatus } from '@typings/common';
import { MerchantInfoState } from '@store/merchant-info/types';
import { fetchMerchantInfoAction } from '@store/merchant-info/actions';

const initialState: MerchantInfoState = {
    merchantInfo: undefined,
    status: LoadingStatus.Idle,
    error: null,
};

export const merchantInfoReducer = createReducer(initialState, (builder) => {
    builder.addCase(fetchMerchantInfoAction.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.merchantInfo = initialState.merchantInfo;
    });
    builder.addCase(fetchMerchantInfoAction.fulfilled, (state, action) => {
        state.status = LoadingStatus.Success;
        state.merchantInfo = action.payload;
    });
    builder.addCase(fetchMerchantInfoAction.rejected, (state, action) => {
        state.status = LoadingStatus.Failure;
        state.error = action.payload;
    });
});
